// src/utils/languages.js
// Loads multiple CSVs from /public/data/*.csv and returns a de-duped,
// alphabetized list with AfriMed preferred languages pinned to the top.

const PREFERRED = ["English", "Portuguese", "French"];

function parseCSV(text) {
  // super-light CSV parser (handles simple commas + quoted cells)
  const rows = [];
  let cur = "", inQuotes = false;
  const pushCell = (arr, cell) => arr.push(cell.replace(/^"|"$/g, "").trim());
  let row = [];

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (ch === '"') {
      // toggle quotes unless it's an escaped quote
      if (inQuotes && text[i + 1] === '"') {
        cur += '"'; i++; // skip escaped quote
      } else {
        inQuotes = !inQuotes;
      }
    } else if (ch === ',' && !inQuotes) {
      pushCell(row, cur); cur = "";
    } else if ((ch === '\n' || ch === '\r') && !inQuotes) {
      if (cur.length || row.length) { pushCell(row, cur); rows.push(row); }
      cur = ""; row = [];
      // handle CRLF by skipping the next \n if needed
      if (ch === '\r' && text[i + 1] === '\n') i++;
    } else {
      cur += ch;
    }
  }
  if (cur.length || row.length) { pushCell(row, cur); rows.push(row); }

  return rows;
}

async function fetchCSV(url) {
  const res = await fetch(url, { cache: "no-cache" });
  if (!res.ok) throw new Error(`Failed to fetch ${url}: ${res.status}`);
  const text = await res.text();
  return parseCSV(text);
}

export async function loadLanguagesFromCSVs(paths) {
  // Load + extract language_name column (case/space tolerant)
  const all = new Set();

  for (const p of paths) {
    try {
      const rows = await fetchCSV(p);
      if (!rows.length) continue;

      const headers = rows[0].map((h) => h.toLowerCase().trim());
      const idx =
        headers.indexOf("language_name") !== -1
          ? headers.indexOf("language_name")
          : headers.findIndex((h) => h.includes("language") && h.includes("name"));

      if (idx === -1) continue;

      for (let r = 1; r < rows.length; r++) {
        const cell = rows[r][idx];
        const name = (cell || "").trim();
        if (name) all.add(name);
      }
    } catch (e) {
      // soft-fail: skip file
      // console.warn(e);
    }
  }

  const arr = Array.from(all);

  // Prepare preferred-first ordering
  const pref = PREFERRED.filter((n) => arr.includes(n));
  const rest = arr
    .filter((n) => !PREFERRED.includes(n))
    .sort((a, b) => a.localeCompare(b));

  return [...pref, ...rest];
}